const config = {
  apiUrl: process.env.REACT_APP_API_URL || "https://api.recetario.com.ar",
  loginGatewayUrl:
    process.env.REACT_APP_LOGIN_GATEWAY_URL ||
    "https://apps.recetario.com.ar/login-gateway",
  homologarApiUrl:
    process.env.REACT_APP_HOMOLOGAR_API_URL || "https://api.recetario.com.ar",
  healthInsurances: {
    cache: {
      key:
        process.env.REACT_APP_HEALTH_INSURANCES_CACHE_KEY ||
        "health-insurances",
      ttl:
        parseInt(process.env.REACT_APP_HEALTH_INSURANCES_CACHE_TTL) ||
        24 * 60 * 60,
    },
  },
  healthCentersRules:
    JSON.parse(process.env.REACT_APP_HEALTH_CENTERS_RULES || null) || [],
  pwa: {
    urls: {
      android: process.env.REACT_APP_PWA_URLS_ANDROID,
      ios: process.env.REACT_APP_PWA_URLS_IOS,
    },
  },
};

export default config;
